import { useState, useEffect } from "react";
const useComponentDimensions = (clientRef) => {
    const getDimensions = () => ({
        width: clientRef.current.offsetWidth,
        height: clientRef.current.offsetHeight,
        clientWidth: clientRef.current.clientWidth,
    });
    const [dimensions, setDimensions] = useState({
        width: 0,
        height: 0,
        clientWidth: 0,
    });
    useEffect(() => {
        const handleResize = () => {
            setDimensions(getDimensions());
        };
        if (clientRef.current) {
            setDimensions(getDimensions());
        }
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [clientRef, clientRef.current]);
    return dimensions;
};
export default useComponentDimensions;
//# sourceMappingURL=useComponentDimensions.js.map